// Камбанка за известия горе-вдясно в заглавната лента — на всеки екран.
// Показва брой непрочетени и отваря екрана с известията.

import React, { useEffect, useState } from 'react';
import { Pressable, Text, View } from 'react-native';
import { navigationRef } from './drawer';
import { BellIcon } from './nav-icons';
import { api } from './api';
import { useAuth } from './AuthContext';
import { COLORS } from './ui';

export function NotificationBell() {
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  const refresh = () => {
    if (!user) return;
    api('/notifications')
      .then((r) => setUnread(r.unreadCount ?? 0))
      .catch(() => {});
  };

  useEffect(() => {
    refresh();
    if (!navigationRef.isReady()) return;
    // при всяка навигация проверяваме отново (напр. след като се отворят известията)
    const unsub = navigationRef.addListener('state', refresh);
    return unsub;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!user) return null;

  return (
    <Pressable
      onPress={() => navigationRef.isReady() && navigationRef.navigate('Notifications' as never)}
      hitSlop={10}
      style={{ paddingHorizontal: 6, paddingVertical: 4 }}
    >
      <BellIcon color={COLORS.text} size={24} />
      {unread > 0 && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            right: 2,
            minWidth: 17,
            height: 17,
            borderRadius: 9,
            paddingHorizontal: 4,
            backgroundColor: COLORS.danger,
            alignItems: 'center',
            justifyContent: 'center',
            borderWidth: 1.5,
            borderColor: COLORS.card,
          }}
        >
          <Text style={{ color: '#fff', fontSize: 10, fontWeight: '800' }}>{unread > 9 ? '9+' : unread}</Text>
        </View>
      )}
    </Pressable>
  );
}
